module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assets-view container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 main"
  }, [_c('div', {
    staticClass: "assets-block",
    attrs: {
      "data-dev-info": ("{ type: 'module', id: '" + _vm.siteId + "' }")
    }
  }, _vm._l((_vm.objectdataImageItems), function(item, index) {
    return _c('div', {
      key: item.key,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.openSidebarFor(item)
        }
      }
    }, [_c('b-card', {
      staticClass: "card_ mb-5",
      class: {
        '_error': item.mandatory === 'true' && item.value === '', '_focus-outline': _vm.isSidebarFocused(item)
      },
      attrs: {
        "data-dev-info": ("{ type: 'item', id: '" + (item.key) + "', position: " + (item.U_Position) + " }"),
        "header-tag": "header"
      }
    }, [_c('div', {
      staticClass: "_image",
      style: (("background-image: url('" + (_vm.getImgSrc(index)) + "')")),
      slot: "header"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "data-infotextkey": _vm.infoTextKeyForItem(item)
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.label) + "\n\t\t\t\t\t\t\t"), (_vm.infoTextForItem(item)) ? _c('erco-tooltip', {
      attrs: {
        "variant": _vm.infoTextForItem(item).variant,
        "title": _vm.infoTextForItem(item).title,
        "text": _vm.infoTextForItem(item).text
      }
    }) : _vm._e()], 1)])], 1)
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9190a618"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/ErcoObjectView/Assets.vue
// module id = 648
// module chunks = 0